import {
    HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        count: 0
    },
    getters: {},
    mutations: {
        setCount(state, count) {
            state.count = count;
        },
        getCount(state) {
            return state.count;
        }
    },
    actions: {
        setStructureFinalCount({
            commit
        }, count) {
            commit('setCount', count);
        },
        getStructureFinalCount() {
            return HTTP.get('/kenya/structures/get_new_count');
        }
    },
}